// extracted by mini-css-extract-plugin
export default {"activeView":"activeView--oyBHz"};